export const accountInformation = [{
    key: 'full_name',
    type: 'text',
    value: '',
    valid: false,
    regex: "^[a-zA-Z]+[a-zA-Z ]+$",
    elementConfig: {
        name: 'full_name',
        label: 'Name',
        placeholder: 'Enter your name'
    },
    validation: {
        required: true,
        message: "is required",
        displayText: "",
    },

}, {
    key: 'gender',
    type: 'select',
    value: '',
    valid: true,
    elementConfig: {
        name: 'gender',
        label: 'Gender',
        options: [{ 'gender': "Male", id: 1 },
        { 'gender': "Female", id: 2 },
        { 'gender': "Others", id: 3 }]
    },
    validation: {
        required: false,
        message: "",
        displayText: "",
    },
}, {
    key: 'short_name',
    type: 'text',
    value: '',
    valid: false,
    regex: "^[a-zA-Z]*[a-zA-Z ]+$",
    elementConfig: {
        name: 'short_name',
        label: 'Short Name',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required",
        displayText: "",
    },
}, {
    key: 'country',
    type: 'select',
    value: '',
    valid: true,
    elementConfig: {
        name: 'country_name',
        label: 'Country',
        options: []
    },
    validation: {
        required: false,
        message: "",
        displayText: "",
    },
}
]



export const basicInformation = [{
    key: 'user_details__alter_email',
    type: 'email',
    value: '',
    valid: false,
    elementConfig: {
        name: 'user_details__alter_email',
        label: 'Alternate email',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required",
        displayText: "",
    },

}, 
// {
//     key: 'mobile_num',
//     type: 'number',
//     value: '',
//     valid: true,
//     elementConfig: {
//         name: 'mobile_num',
//         label: 'Mobile Number',
//         placeholder: 'enter phone number'
//     },
//     validation: {
//         min:10,
//         required: false,
//         message: "Should be 10 digits",
//         displayText: "",
//     },
// }, {
//     key: 'user_details__work_phone',
//     type: 'number',
//     value: '',
//     valid: true,
//     elementConfig: {
//         name: 'user_details__work_phone',
//         label: 'Work Number',
//         placeholder: ''
//     },
//     validation: {
//         min:10,
//         required: false,
//         message: "Should be 10 digits",
//         displayText: "",
//     },
// },
 {
    key: 'user_details__city',
    type: 'text',
    value: '',
    valid: false,
    elementConfig: {
        name: 'user_details__city',
        label: 'City',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required",
        displayText: "",
    },
}, {
    key: 'user_details__occupation',
    type: 'text',
    value: '',
    valid: true,
    elementConfig: {
        name: 'user_details__occupation',
        label: 'Occupation',
        placeholder: ''
    },
    validation: {
        required: false,
        message: "is required",
        displayText: "",
    },
}, {
    key: 'user_details__industry__id',
    type: 'select',
    value: '',
    valid: false,
    elementConfig: {
        name: 'user_details__industry__demographic_name',
        label: 'Industry',
        options: []
    },
    validation: {
        required: true,
        message: "is required",
        displayText: "",
    },
}, {
    key: 'user_details__designation',
    type: 'text',
    value: '',
    valid: true,
    elementConfig: {
        name: 'user_details__designation',
        label: 'Designation',
        options: []
    },
    validation: {
        required: false,
        message: "is required",
        displayText: "",
    },
}, {
    key: 'user_details__qualification__id',
    type: 'select',
    value: '',
    valid: true,
    elementConfig: {
        name: 'user_details__qualification__demographic_name',
        label: 'Qualification',
        options: []
    },
    validation: {
        required: false,
        message: "is required",
        displayText: "",
    },
}, {
    key: 'user_details__work_experience',
    type: 'number',
    value: '',
    valid: true,
    elementConfig: {
        name: 'user_details__work_experience',
        label: 'Work Experience',
        placeholder: ''
    },
    validation: {
        required: false,
        message: "",
        displayText: "",
    },
}, {
    key: 'user_details__tenure_in_company',
    type: 'number',
    value: '',
    valid: true,
    elementConfig: {
        name: 'user_details__tenure_in_company',
        label: 'Tenure in Company',
        placeholder: ''
    },
    validation: {
        required: false,
        message: "",
        displayText: "",
    },
},
{
    key: 'user_details__marital_status_id',
    type: 'select',
    value: '',
    valid: true,
    elementConfig: {
        name: 'user_details__marital_status',
        label: 'Marital Status',
        options: [{ 'user_details__marital_status': 'Single', 'id': 1 },
        { 'user_details__marital_status': 'Married', 'id': 2 },
        { 'user_details__marital_status': 'Divorced', 'id': 3 },
        { 'user_details__marital_status': 'Widow', 'id': 4 }]
    },
    validation: {
        required: false,
        message: "is required",
        displayText: "",
    },
},
]

export const dobToggleControl = [{
    key: 'Blank Date',
    type: 'radio',
    value: '',
    valid: true,
    elementConfig: {
        name: 'radio',
        label: 'Blank Date',
        placeholder: ''
    },
    validation: {
        required: false,
        message: "is required",
        displayText: "",
    },

},{
    key: 'Set Date',
    type: 'radio',
    value: 'true',
    valid: true,
    elementConfig: {
        name: 'radio',
        label: 'Set Date',
        placeholder: ''
    },
    validation: {
        required: false,
        message: "is required",
        displayText: "",
    },
}]

export const dobInformation = [{
    key: 'year',
    type: 'number',
    value: '',
    valid: false,
    elementConfig: {
        name: 'year',
       label: 'Year',
        placeholder:'Enter Birth Year',
    },
    validation: {
        minYear:1900,
        maxYear:0,
        server_time: '',
        required: true,
        message: "is required and DOB should between 1900 and current year",
        displayText: "",
    },
},{
    key: 'month',
    type: 'select',
    value: '',
    valid: true,
    elementConfig: {
        name: 'month',
        label: 'Month',
        options: [
            {"month":'January',"label":"Jan","id":1},
            {"month":'February',"label":"Feb","id":2},
            {"month":'March',"label":"Mar","id":3},
            {"month":'April',"label":"Apr","id":4},
            {"month":'May',"label":"May","id":5},
            {"month":'June',"label":"Jun","id":6},
            {"month":'July',"label":"Jul","id":7},
            {"month":'August',"label":"Aug","id":8},
            {"month":'September',"label":"Sep","id":9},
            {"month":'October',"label":"Oct","id":10},
            {"month":'November',"label":"Nov","id":11},
            {"month":'December',"label":"Dec","id":12}
        ]
    },
    validation: {
        required: true,
        message: "is required",
        displayText: "",
    },
},{
    key: 'day',
    type: 'select',
    value: '',
    valid: true,
    elementConfig: {
        name: 'day',
        label: 'Date',
        options: []
    },
    validation: {
        
        required: true,
        message: "is required",
        displayText: "",
    },
},]


export const additionalInformation = [{
    key: 'user_details__keep_posted_on_discoverself',
    type: 'checkbox',
    value: '',
    valid: true,
    elementConfig: {
        name: 'user_details__keep_posted_on_discoverself',
        label: 'Keep me posted on OPPTiMiSE updates',
        placeholder: ''
    },
    validation: {
        required: false,
        message: "is required",
        displayText: "",
    },

}, {
    key: 'user_details__no_of_children',
    type: 'number',
    value: '',
    valid: true,
    elementConfig: {
        name: 'user_details__no_of_children',
        label: 'No. of childrens(In integer)',
        placeholder: 'No. of childrens(In integer)'
    },
    validation: {
        required: false,
        message: "",
        displayText: "",
    },
}, {
    key: 'user_details__family_type',
    type: 'select',
    value: '',
    valid: true,
    elementConfig: {
        name: 'user_details__family_type',
        label: 'Family Type',
        options: [{"user_details__family_type":'Joint',"id":'Joint'},
        {"user_details__family_type":'Extended',"id":'Extended'},
        {"user_details__family_type":'Nuclear',"id":'Nuclear'},]
    },
    validation: {
        required: false,
        message: "",
        displayText: "",
    },
}, {
    key: 'user_details__hobbies',
    type: 'text',
    value: '',
    valid: true,
    elementConfig: {
        name: 'user_details__hobbies',
        label: 'Hobbies',
        placeholder:'',
    },
    validation: {
        required: false,
        message: "is required",
        displayText: "",
    },
}, {
    key: 'user_details__annual_income',
    type: 'select',
    value: '',
    valid: true,
    elementConfig: {
        name: 'user_details__annual_income',
        label: 'Annual Income',
        options: [{"user_details__annual_income":"<$100,000","id":'<100,000'},
        {"user_details__annual_income":"$100,000-$250,000","id":'100,000-250,000'},
        {"user_details__annual_income":"$250,000-$500,000","id":'250,000-500,000'},
        {"user_details__annual_income":"$500,000-$1 million","id":'500,000-1million'},
        {"user_details__annual_income":">$1 million","id":'>1million'},]
    },
    validation: {
        required: false,
        message: "is required",
        displayText: "",
    },
}, {
    key: 'user_details__previous_assesment_list',
    type: 'textarea',
    value: '',
    valid: false,
    elementConfig: {
        name: 'user_details__previous_assesment_list',
        label: 'Have you taken any self-assessments before? Please list them',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required",
        displayText: "",
    },
}, {
    key: 'user_details__add_to_discoverself_blog',
    type: 'checkbox',
    value: '',
    valid: true,
    elementConfig: {
        name: 'user_details__add_to_discoverself_blog',
        label: 'Add me to the OPPTiMiSE blog',
    },
    validation: {
        required: false,
        message: "is required",
        displayText: "",
    },
}
]





// WEBPACK FOOTER //
// ./src/_pages/Dashboard/user-details/userDetailsFormData.js